import {createApi} from "@reduxjs/toolkit/query/react"
import {apiQueryV1} from "../utils/Extensions"

export const cancelSendingApi = createApi({
    reducerPath: "cancelSendingApi",
    baseQuery: apiQueryV1,
    endpoints: (builder) => ({
        cancelSending: builder.mutation({
            query: (orderId: number) => ({
                url: "/deliveries/cancel-sending",
                method: "PATCH",
                body: {orderId}
            })
        })
    })
})

export const {
    useCancelSendingMutation,
} = cancelSendingApi